import React, { useMemo } from "react";
import { ChatListItem } from "@web-src/modules/chats/components/ChatListItem";
import { ChatListItemLastMessage } from "@web-src/modules/chats/components/ChatListItemLastMessage";
import { tokenizeMessageBody } from "@web-src/modules/chats/utils";
import { CHAT_MESSAGE_PAYLOAD_VERSION } from "@jugl-web/utils/consts";
import { TwilioConversationModel } from "@jugl-web/rest-api";
import SMSIcon from "./assets/sms.png";
import { useClientSupportPageContext } from "../../../../providers/ClientSupportPageProvider/useClientSupportPageContext";
import { CRMAgentInfo } from "../CRMAgentInfo";

export const TwilioConversationTile: React.FC<{
  conversation: TwilioConversationModel;
  searchQuery?: string;
}> = ({ conversation, searchQuery }) => {
  const { selectedConversation, selectConversation } =
    useClientSupportPageContext();

  const lastMessageBody = useMemo(
    () => conversation.payload.text || "",
    [conversation]
  );

  // Use name (phone number) as the display name
  const displayName = useMemo(() => {
    return conversation.contact_info?.name || conversation.name || "Unknown";
  }, [conversation.contact_info?.name, conversation.name]);

  return (
    <ChatListItem
      img={SMSIcon}
      chatId={conversation.conv_id}
      onClick={() => selectConversation(conversation)}
      timestamp={conversation.payload.timestamp}
      isSelected={selectedConversation?.conv_id === conversation.conv_id}
      title={displayName}
      lastMessageContent={
        <ChatListItemLastMessage
          payloadVersion={CHAT_MESSAGE_PAYLOAD_VERSION}
          tokenizedMessage={tokenizeMessageBody(lastMessageBody)}
        />
      }
      additionalContent={<CRMAgentInfo conversation={conversation} />}
      showUnreadIndicator={
        conversation.type === "incoming" && !conversation.read
      }
      searchQuery={searchQuery}
      hasChatAccess
    />
  );
};
